<template>
    <v-dialog v-model="showDialog" max-width="1150">
        <v-card flat>
            <div ref="scrollContainer" style="max-height: 80vh; overflow-y: auto; position: relative;">
                <v-btn
                    fab
                    color="secondary"
                    x-small
                    class="float-right"
                    style="position: sticky; top: 15px; right: 15px; z-index: 10;"
                    @click="showDialog = false"
                >
                    <v-icon>{{ mdiClose }}</v-icon>
                </v-btn>
                <v-card-title style="position: relative;">
                    <v-icon
                        v-if="screen_width > 371"
                        x-large
                        size="30"
                        style="padding: 2px; border-radius: 5px; background-color: #4EB352; width: 50px; height: 50px;"
                        class="white--text"
                    >
                        {{ mdiHospitalBuilding }}
                    </v-icon>
                    <div :style="`${screen_width > 371 ? 'width: 40vw; max-width: 600px;' : 'max-width: 220px;'}; margin-left: 25px; vertical-align: top;`">
                        <h4 style="margin: 0; padding: 0; line-height: 1; color: #333; font-weight: 750; display: block; word-break: break-word;">
                            {{ selectedHosp && selectedHosp.hosp_name }}
                        </h4>
                        <span style="display: block; font-size: 15px; margin: 5px 0 0 0; padding: 0; word-break: break-word; line-height: 1;">{{ toTitleCase(selectedHosp) }}</span>
                    </div>
                </v-card-title>
                <v-card-subtitle
                    style="border-bottom: 3px solid #4EB352;"
                    class="clinic-doctor-subtitle"
                >
                    <ul>
                        <li>{{ orderedDoctors && orderedDoctors.length }}<span>Total Doctors</span></li>
                        <li>{{ totalSpecialization && totalSpecialization.length }}<span>Specializations</span></li>
                    </ul>
                </v-card-subtitle>
                <v-data-table
                    :headers="header"
                    :items="filteredDoctors"
                    :items-per-page="options.itemsPerPage"
                    :page.sync="options.page"
                    :search="search.query"
                    hide-default-footer
                    class="clinic-doctor-tbl"
                >
                    <!-- :loading="loading.tempClinic" -->
                    <template #top>
                        <v-row align="center" no-gutters>
                            <!-- Title -->
                            <v-col cols="12" :lg="undefined" class="d-flex align-center">
                                <v-icon class="mr-2" color="green" style="margin-left: 5px;">
                                    {{ mdiDoctor }}
                                </v-icon>
                                <h1 class="font-weight-medium text-h6 mb-0">
                                    Available Doctors
                                </h1>
                            </v-col>

                            <!-- Search -->
                            <v-col
                                cols="12"
                                md="6"
                                lg="4"
                                style="padding: 5px 0"
                            >
                                <v-text-field
                                    v-model="search.value"
                                    hide-details
                                    single-line
                                    outlined
                                    dense
                                    color="success"
                                    placeholder="Search doctors, specialization ..."
                                    class="mx-2"
                                    clearable
                                    :append-icon="mdiMagnify"
                                    style="margin: 2px 0"
                                    @keyup.enter="search.query = search.value"
                                    @click:append="search.query = search.value"
                                    @click:clear="search.query = null"
                                />
                            </v-col>

                            <!-- Specialization -->
                            <v-col
                                cols="12"
                                md="6"
                                lg="4"
                                style="padding: 5px 0"
                            >
                                <v-autocomplete
                                    v-model="search.specialization"
                                    :items="totalSpecialization"
                                    item-text="name"
                                    item-value="name"
                                    clearable
                                    dense
                                    color="success"
                                    outlined
                                    hide-details
                                    class="mx-2"
                                    placeholder="Filter by specialization ..."
                                    :prepend-inner-icon="mdiStethoscope"
                                    style="margin: 2px 0"
                                />
                            </v-col>

                            <!-- Footer -->
                            <v-col cols="12" lg="4">
                                <v-data-footer
                                    style="border-top: transparent;"
                                    :options.sync="options"
                                    :pagination="pagination"
                                    :items-per-page-options="[5, 10, 20, 50, 100, 200, -1]"
                                    :items-per-page-text="`${screen_width > 371 ? 'Show' : ''}`"
                                />
                            </v-col>
                        </v-row>
                    </template>
                    <template #foot>
                        <div>
                            <v-data-footer
                                v-if="filteredDoctors && filteredDoctors.length > 5"
                                style="border-top: transparent;"
                                :options.sync="options"
                                :pagination="pagination"
                                :items-per-page-options="[5, 10, 20, 50, 100, 200, -1]"
                                :items-per-page-text="`${screen_width > 371 ? 'Show' : ''}`"
                            />
                        </div>
                    </template>
                    <template #[`item.doc_name`]="{ item }">
                        <span v-if="item.doc_name" style="font-weight: 700;">{{ item.doc_name }}</span>
                    </template>
                    <template #[`item.sp_desc`]="{ item }">
                        <span v-if="item.sp_desc">{{ item.sp_desc }}</span>
                    </template>
                    <template #[`item.af_roomno`]="{ item }">
                        <span style="color: #4EB352; font-weight: 700; ">{{ item.af_roomno }}</span>
                    </template>
                </v-data-table>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
import { mdiClose, mdiDoctor, mdiHospitalBuilding, mdiMagnify, mdiStethoscope } from '@mdi/js'
import { mapGetters, mapActions } from 'vuex'
export default {
    props: ['show', 'clinic', 'selectedHosp', 'loading'],
    data() {
        return {
            mdiClose, mdiDoctor, mdiHospitalBuilding, mdiMagnify, mdiStethoscope,
            goToOptions: {
                duration: 0,
                offset: 700,
                easing: 'easeInOutCubic'
            },
            search: {
                value: null,
                query: null,
                specialization: null
            },
            options: {
                page: 1,
                itemsPerPage: 10,
                sortBy: [],
                sortDesc: [],
                groupBy: [],
                groupDesc: [],
                multiSort: false,
                mustSort: false
            },
            pageCount: 0,
            header: [
                { text: 'Doctor', sortable: true, value: 'doc_name' },
                { text: 'Specialization', sortable: true, value: 'sp_desc' },
                { text: 'Schedule', sortable: false, value: 'af_sched' },
                { text: 'Room No', sortable: false, value: 'af_roomno' }
            ],
            screen_width: document.documentElement.clientWidth + 9
        }
    },
    computed: {
        ...mapGetters(['getRegions', 'getProvinces', 'getCities', 'getHospClin', 'getHospClinDialog']),
        showDialog: {
            get() {
                return this.show
            },
            set() {
                this.resetForm()
                this.$emit('closeDialog')
            }
        },
        filteredDoctors() {
            const query = this.search.query ? this.search.query.toLowerCase() : ''
            const specialization = this.search.specialization ? this.search.specialization.toLowerCase() : ''

            return this.orderedDoctors.filter(doc => {
                const nameMatch = doc.doc_name && doc.doc_name.toLowerCase().includes(query)
                const specMatch = doc.sp_desc && doc.sp_desc.toLowerCase().includes(query)

                const matchesSearch = query ? nameMatch || specMatch : true
                const matchesSpecialization = specialization ? doc.sp_desc && doc.sp_desc.toLowerCase().includes(specialization.toLowerCase()) : true

                return matchesSearch && matchesSpecialization
            })
        },
        pagination() {
            const totalItems = this.filteredDoctors.length

            if (this.options.itemsPerPage === -1) {
                return {
                    page: 1,
                    itemsPerPage: totalItems,
                    pageCount: 1,
                    itemsLength: totalItems,
                    pageStart: totalItems > 0 ? 1 : 0,
                    pageStop: totalItems
                }
            }

            const start = ((this.options.page - 1) * this.options.itemsPerPage + 1) - 1
            const stop = Math.min(
                this.options.page * this.options.itemsPerPage,
                totalItems
            )

            return {
                page: this.options.page,
                itemsPerPage: this.options.itemsPerPage,
                pageCount: Math.ceil(totalItems / this.options.itemsPerPage),
                itemsLength: totalItems,
                pageStart: totalItems === 0 ? 0 : start,
                pageStop: totalItems === 0 ? 0 : stop
            }
        },
        totalSpecialization() {
            const uniqueSpecs = []

            if (this.orderedDoctors && this.orderedDoctors.length > 0) {
                this.orderedDoctors.forEach(doc => {
                    [doc.doc_specialization_1, doc.doc_specialization_2, doc.doc_specialization_3].forEach(spec => {
                        if (spec && spec.trim() && !uniqueSpecs.includes(spec.trim())) {
                            uniqueSpecs.push(spec.trim())
                        }
                    })
                })
            }
            const sortedUniqueSpecs = uniqueSpecs.length > 0 ? uniqueSpecs.sort((a, b) => a.localeCompare(b)) : []
            return sortedUniqueSpecs
        },
        orderedDoctors: {
            get() {
                let arr = this.getHospClinDialog
                for (let i = 0; i < arr.length; i++) {
                    let sp = this.wrapSpecializations(arr[i])
                    arr[i].sp_desc = sp
                }
                return arr
            }
        }
    },
    mounted() {
        window.addEventListener('resize', this.onResize)
    },
    destroyed() {
        window.removeEventListener('resize', this.onResize)
    },
    methods: {
        ...mapActions(['regions', 'provinces', 'cities', 'specializations', 'doctors', 'getCsrfToken', 'doctorsDialog']),
        resetForm() {
            this.search.value = null
            this.search.query = null
            this.search.specialization = null
            this.options = {
                page: 1,
                itemsPerPage: 10,
                sortBy: [],
                sortDesc: [],
                groupBy: [],
                groupDesc: [],
                multiSort: false,
                mustSort: false
            }
            this.$nextTick(() => {
                const el = this.$refs.scrollContainer
                if (el) {
                    this.$vuetify.goTo(el, { ...this.goToOptions, container: el })
                }
            })
        },
        handleCloseBtn() {
            this.search.value = null
            this.search.query = null
            this.search.specialization = null
            this.options = {
                page: 1,
                itemsPerPage: 10,
                sortBy: [],
                sortDesc: [],
                groupBy: [],
                groupDesc: [],
                multiSort: false,
                mustSort: false
            }
            this.$emit('closeDialog')
        },
        toTitleCase(str) {
            if (str && str.hosp_address) {
                return str.hosp_address
                    .toLowerCase()
                    .replace(/\b\w+/g, word => word.charAt(0).toUpperCase() + word.slice(1))
            }
        },
        wrapSpecializations({ doc_specialization_1, doc_specialization_2, doc_specialization_3 }) {
            let spec_str = []
            if(doc_specialization_1 !== null && String(doc_specialization_1).trim() !== '') spec_str.push(String(doc_specialization_1).trim())
            if(doc_specialization_2 !== null && String(doc_specialization_2).trim() !== '') spec_str.push(String(doc_specialization_2).trim())
            if(doc_specialization_3 !== null && String(doc_specialization_3).trim() !== '') spec_str.push(String(doc_specialization_3).trim())
            let str = ''
            for (let i = 0; i < spec_str.length; i++) {
                str += spec_str[i]
                if(i < spec_str.length - 1) {
                    str += ' - '
                }
            }
            return str
        },
        onResize() {
            this.screen_width = document.documentElement.clientWidth
        }
    }
}
</script>

<style>
.clinic-doctor-tbl > div > table > thead > tr > th {
    position: sticky !important;
    position: -webkit-sticky !important;
    top: 0;
    z-index: 1;
    background: white;
}
  .sp-desc-chip {
    width: fit-content; /* Adjust as needed */
    height: auto; /* Adjust to fit two lines */
    padding: 5px 10px;
    margin-top: 5px;
    border-radius: 25px;
    background: linear-gradient(135deg, #4EB352 0%, #20B2AA 100%);
    color: white;
    font-weight: 700;
    font-size: 0.875rem; /* Equivalent to 14px */
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    text-wrap: balance;
  }
.clinic-doctor-subtitle ul {
  margin: 15px 0 0 0;
  padding-left: 0;
  list-style-type: none;
}
  .clinic-doctor-subtitle ul li {
    letter-spacing: 2px;
    background-color: #eee;
    width: 100px;
    height: 80px;
    color: #4EB352;
    font-weight: 700;
    font-size: 22px;
    display: inline-block;
    text-align: center;
    margin: 0 10px 0 0;
    border: 1px solid #ddd;
    border-radius: 10px;
    padding: 15px 9px 9px 9px;
    vertical-align: top;
  }
    .clinic-doctor-subtitle ul li span {
      margin-top: 5px;
      text-wrap: nowrap;
      letter-spacing: normal;
      color: #555;
      word-wrap: none;
      font-weight: 500;
      font-size: 12px;
      display: block;
    }
</style>
